import { defineMessages } from 'react-intl';

export default defineMessages({
  actualPage: { id: 'gofre.Ui.Pagination.actual' },
  goPage: { id: 'gofre.Ui.Pagination.goto' },
  nextPage: { id: 'gofre.Ui.Pagination.next' },
  prevPage: { id: 'gofre.Ui.Pagination.prev' },
  elements: { id: 'gofre.Ui.Pagination.elements' },
});
